<div class="sidenav-content">
  <div class="sidenav-top-portion">
    <div class="sidenav-header" [class.collapsed]="isCollapsed()">
      @if (isCollapsed()) {
        <div class="collapsed-nav-logo">
          <img src="images/ADB_small_logo.png" width="32" height="32" />
        </div>
      } @else {
        <img src="images/ADB_small_logo.png" width="32" height="32" />
      }
    </div>
    @if (!isCollapsed()) {
      <product-name />
    }
    <navigation-links [isCollapsed]="isCollapsed()" />
    <div class="divider" [class.collapsed]="isCollapsed()"></div>
    @if (!isCollapsed()) {
      <recent-chats-section />
    }
  </div>
  <nav-footer [(isCollapsed)]="isCollapsed" />
</div>
